export enum ClockState {
  Idle = 'idle',
  ClockedIn = 'clocked-in',
  OnBreak = 'on-break',
}

export enum RequestStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum TimeLogColumn {
  In = 'In',
  Out = 'Out',
  Duration = 'Duration',
  Type = 'Type',
  Note = 'Note',
}

export enum LogType {
  Clock = 'clock',
  Break = 'break',
}

export enum DayStatus {
  Full = 'full',
  Partial = 'partial',
  Off = 'off',
  Leave = 'leave',
  Holiday = 'holiday',
}
